import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.1.1@rc-notification/es/index.js
// module id = 193
// module chunks = 1